export default "__VITE_ASSET__BH8Pdi12__"